import { createContext, useContext, useEffect, useMemo, useRef, useState, type ReactNode } from "react";

const NowContext = createContext<number>(Date.now());

interface NowProviderProps {
  intervalMs?: number;
  children: ReactNode;
}

export function NowProvider({ intervalMs = 60_000, children }: NowProviderProps) {
  const [now, setNow] = useState<number>(() => Date.now());
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setNow(Date.now());
    }, intervalMs);
    return () => {
      if (intervalRef.current !== null) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [intervalMs]);

  const value = useMemo(() => now, [now]);

  return <NowContext.Provider value={value}>{children}</NowContext.Provider>;
}

export function useNow(): number {
  return useContext(NowContext);
}
